import './PropertyTypes.scss';

import house from '../../images/house.jpg';
import apartment from '../../images/apartment.jpg';
import condo from '../../images/condo.jpg';
import villa from '../../images/villa.jpg';
import town from '../../images/town.jpg';

import { FaHome, FaBuilding, FaCity, FaHotel } from 'react-icons/fa';

export default function PropertyTypes() {

    const types = [
        { name: 'Buy & Sell', img: house, icon: <FaHome /> },
        { name: 'Apartment', img: apartment, icon: <FaBuilding /> },
        { name: 'Rent', img: condo, icon: <FaCity /> },
        { name: 'Retail', img: villa, icon: <FaHotel /> },
        { name: 'Commercial', img: town, icon: <FaHome /> },
    ];

    return (
        <section className="types">
            <div className="container">

                <h2>Explore Our Properties</h2>
                <p className="sub-text">
                    Discover the future of life style with smart , saving , social and full your expectation                </p>

                <div className="grid">
                    {types.map((item, i) => (
                        <div className="card" key={i}>

                            <img src={item.img} alt={item.name} />

                            <div className="overlay-property-type">
                                <div className="icon">{item.icon}</div>
                                <h3>{item.name}</h3>
                            </div>

                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
}